import React from "react";
import styled from "styled-components";

import { Text } from "@components/Text";

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ff000052;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ContainerText = styled.div`
  width: 100%;
  padding-top: 24px;
  padding-bottom: 24px;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const FireAlarm = () => {
  return (
    <Container>
      <ContainerText>
        <Text color="red" fontSize="58px" fontWeight="600">
          FIRE ALARM
        </Text>
      </ContainerText>
    </Container>
  );
};
